import React from 'react';
import { Routes, Route } from 'react-router-dom';

import AboutPage from './AboutPage';
import AdminPage from './AdminPage';
import AuthOverlay from './AuthOverlay';
import DoubaoPage from './DoubaoPage';
import GuardPage from './GuardPage';
import HomePage from './HomePage';
import LandingPage from './LandingPage';
import NewsPage from './NewsPage';
import PricingPage from './PricingPage';
import ProfilePage from './ProfilePage';
import TermsPage from './TermsPage';

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<LandingPage />} />
    <Route path="/login" element={<AuthOverlay />} />
    <Route path="/verify" element={<AuthOverlay />} />
    <Route path="/home" element={<HomePage />} />
    <Route path="/pricing" element={<PricingPage />} />
    <Route path="/profile" element={<ProfilePage />} />
    <Route path="/news" element={<NewsPage />} />
    <Route path="/doubao" element={<DoubaoPage />} />
    <Route path="/guard" element={<GuardPage />} />
    <Route path="/terms" element={<TermsPage />} />
    <Route path="/admin" element={<AdminPage />} />
    <Route path="/about" element={<AboutPage />} />
  </Routes>
);

export default AppRoutes;
